export default "__VITE_ASSET__92a44b7d__"